import Topbar from "../components/topbar/Topbar";
import Header from "../components/navbar/Header";
import About from "../components/about_hospital/About_hospital";
import Footer from "../components/footer/Footer";

export default function AboutHospitalPage() {
  return (
    <>
      <Topbar />
      <Header />
      <About />
      <Footer />
    </>
  );
}
